import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20fantasy%20scene%20of%20misty%20mountain%20peaks%20among%20clouds%20at%20dawn%2C%20a%20lone%20cultivator%20in%20flowing%20robes%20standing%20on%20a%20cliff%20with%20a%20sword%2C%20cranes%20flying%20in%20the%20distance%2C%20warm%20cinnabar%20red%20and%20golden%20sunlight%20breaking%20through%2C%20elegant%20oriental%20minimalism%2C%20soft%20warm%20paper%20tones%2C%20high%20detail%2C%20atmospheric%20wuxia%20cultivation%20aesthetic&width=1600&height=900&seq=hero-shixiong&orientation=landscape"
          alt="水墨仙侠风格的青山云海与御剑修士"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="font-seal rounded-full border border-background-50/40 bg-background-50/10 px-4 py-1 text-lg tracking-widest text-background-50 backdrop-blur-sm">
          国漫 · 仙侠 · 考据嗑糖
        </span>
        <h1 className="mt-6 font-heading text-4xl font-black leading-tight tracking-wide text-background-50 md:text-6xl">
          师兄啊师兄
          <span className="mt-2 block text-2xl font-bold text-accent-300 md:text-4xl">人物关系 · CP线 · 师门日常</span>
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-7 text-background-100/90 md:text-base md:leading-8">
          深度整理师兄师姐互动名场面、同门情谊细节与 CP 线发展脉络。师门日常高甜片段、人物关系图谱持续更新，
          磕糖考据党必备的追更指南，一网打尽。
        </p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/characters"
            className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 shadow-md transition-colors hover:bg-primary-400"
          >
            查看人物关系图谱
          </Link>
          <Link
            to="/daily"
            className="whitespace-nowrap rounded-md border border-background-50/50 bg-background-50/10 px-7 py-3.5 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/25"
          >
            逛逛师门日常
          </Link>
        </div>

        <div className="mt-12 grid w-full max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4">
          {[
            { num: '6+', label: '核心角色' },
            { num: '4', label: 'CP线梳理' },
            { num: '20+', label: '高甜名场面' },
            { num: '持续', label: '考据更新' },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/20 bg-background-50/10 px-4 py-4 backdrop-blur-sm"
            >
              <p className="font-heading text-2xl font-bold text-accent-300">{s.num}</p>
              <p className="mt-1 text-xs tracking-wide text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}